// extracted by mini-css-extract-plugin
export default {"lowSupplyCard":"lowSupplyCard__ZTJlZ","dek":"dek__YzQ2Z"};